export const COMPANY = {
  name: "Solar Pros Cleaning Services",
  phone: "(903) 780-6957",
  phoneHref: "tel:+19037806957",
  email: "Lane.Davis@solarproscleaningsvc.com",
  emailHref: "mailto:Lane.Davis@solarproscleaningsvc.com",
  area: "Serving Texas",
  facebook: "https://facebook.com",
};

export const NAV = [
  { label: "HOME", to: "/", end: true },
  { label: "SERVICES", to: "/services" },
  { label: "ABOUT US", to: "/about" },
  { label: "GALLERY", to: "/gallery" },
  { label: "CONTACT", to: "/contact" },
];

export const SERVICE_AREAS = [
  "Tyler", "Longview", "Kilgore", "Henderson", "Athens", "Palestine",
  "Canton", "Jacksonville", "Nacogdoches", "Lufkin", "Waco", "Temple",
  "Killeen", "Corsicana", "Dallas", "Fort Worth", "Austin", "San Antonio",
  "San Marcos", "College Station", "Houston", "…and surrounding areas",
];

export const SERVICE_TYPES = [
  "Residential Cleaning",
  "Commercial Cleaning",
  "Utility-Scale Solar Farm",
  "General Inquiry",
];
